import { render, staticRenderFns } from "./nutzungsbedingungen.vue?vue&type=template&id=5d0dc98e&"
import script from "./nutzungsbedingungen.vue?vue&type=script&lang=js&"
export * from "./nutzungsbedingungen.vue?vue&type=script&lang=js&"
import style0 from "./nutzungsbedingungen.vue?vue&type=style&index=0&id=5d0dc98e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports